export default "__VITE_ASSET__ThjIkF2Y__$_?format=webp__"